import { createSelector } from "reselect";

import { RootState } from "../rootReducer";

const uiSyncState = (state: RootState) => state.uiSync;
export const getListeners = createSelector(uiSyncState, ({ listeners }) => listeners);
